<div>
  <form [formGroup]="form" (ngSubmit)="modelRecived ? update(form.getRawValue()) : create(form.value)" class="mt-3" appPermissionControl="P107F0001">
    <div class="form-row mt-3">
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="claveEmpresa" maxlength="50" appPermissionControl="P107K0001" />
        <label>Clave Empresa</label>
      </div>

      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="claveSucursal" maxlength="4" [attr.disabled]="modelRecived ? '' : null" appPermissionControl="P107K0002" />
        <label>Clave Sucursal *</label>
        <small class="text-danger" *ngIf="formValue('claveSucursal')?.errors?.required && formValue('claveSucursal')?.touched"> La clave de sucursal es requerida </small>
        <small class="text-danger" *ngIf="(formValue('claveSucursal')?.errors?.minlength || formValue('claveSucursal')?.errors?.maxlength) && formValue('claveSucursal')?.touched">
          La clave de sucursal debe tener 4 caracteres
        </small>
      </div>
    </div>

    <div class="form-row mt-3">
      <div class="form-field flex-grow-1">
        <input type="text" class="form-control" formControlName="nombreSucursal" maxlength="50" appPermissionControl="P107K0003" />
        <label>Nombre Sucursal *</label>
        <small class="text-danger" *ngIf="formValue('nombreSucursal')?.errors?.required && formValue('nombreSucursal')?.touched"> El nombre de sucursal es requerido </small>
      </div>

      <div class="form-field flex-grow-1">
        <select class="form-control" formControlName="ciudad" appPermissionControl="P107K0004">
          <option value="">Seleccione ciudad</option>
          <option *ngFor="let ciudad of listCiudades" [value]="ciudad.claveCD">
            {{ ciudad.ciu_mun_del }}
          </option>
        </select>
        <label>Ciudad *</label>
        <small class="text-danger" *ngIf="formValue('ciudad')?.errors?.required && formValue('ciudad')?.touched"> La ciudad es requerida </small>
      </div>
    </div>

    <div class="button-section mt-3">
      <button mat-flat-button type="submit" [disabled]="!form.valid || loading" class="btn-edit" appPermissionControl="P107B0001">
        <mat-icon>save</mat-icon>
        {{ loading ? (modelRecived ? 'Actualizando...' : 'Guardando...') : modelRecived ? 'Actualizar' : 'Guardar' }}
      </button>
      <ng-container *ngIf="modelRecived">
        <button mat-flat-button class="btn-search" (click)="customizables()" appPermissionControl="P107B0002">
          <mat-icon>receipt</mat-icon>
          Customizables
        </button>
        <button mat-flat-button class="btn-func" (click)="promociones()" appPermissionControl="P107B0003">
          <mat-icon>local_offer</mat-icon>
          Promociones
        </button>
      </ng-container>
    </div>
  </form>
</div>
